import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { Settings } from "luxon";
import sv from "./locales/sv";
import en from "./locales/en";

export const I18N_STORAGE_KEY = "adminI18nLng";

function readStoredLanguage(): "sv" | "en" {
  if (typeof localStorage === "undefined") {
    return "sv";
  }
  let stored: string | null = null;
  try {
    stored = localStorage.getItem(I18N_STORAGE_KEY);
  } catch {
    return "sv";
  }
  return stored === "en" || stored === "sv" ? stored : "sv";
}

function syncLuxonLocale(lng: string) {
  Settings.defaultLocale = lng === "en" ? "en" : "sv";
}

const initialLng = readStoredLanguage();
syncLuxonLocale(initialLng);

i18n.use(initReactI18next).init({
  resources: {
    sv,
    en,
  },
  lng: initialLng,
  fallbackLng: "sv",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  syncLuxonLocale(lng);
});

export function setAppLanguage(lng: "sv" | "en") {
  if (typeof localStorage !== "undefined") {
    try {
      localStorage.setItem(I18N_STORAGE_KEY, lng);
    } catch {
      void 0;
    }
  }
  return i18n.changeLanguage(lng);
}
